import type { CSSProperties, DragEventHandler, MouseEventHandler, ReactNode } from "react";

interface CellWrapProps {
  children: ReactNode;
  rowH?: number;
  align?: "flex-start" | "center" | "right";
  pad?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  interactive?: boolean;
  style?: CSSProperties;
  // Drag-and-drop upload (FileCell). Additive and optional — every other cell
  // leaves these undefined and renders exactly as before.
  onDragOver?: DragEventHandler<HTMLDivElement>;
  onDragLeave?: DragEventHandler<HTMLDivElement>;
  onDrop?: DragEventHandler<HTMLDivElement>;
}

export function CellWrap({
  children,
  rowH = 44,
  align = "flex-start",
  pad = "0 12px",
  onClick,
  interactive = true,
  style,
  onDragOver,
  onDragLeave,
  onDrop,
}: CellWrapProps) {
  const justifyContent =
    align === "right" ? "flex-end" : align === "center" ? "center" : "flex-start";
  return (
    <div
      onClick={onClick}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      style={{
        height: rowH,
        padding: pad,
        display: "flex",
        alignItems: "center",
        justifyContent,
        cursor: interactive && onClick ? "pointer" : "default",
        width: "100%",
        boxSizing: "border-box",
        position: "relative",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
